<template>
    <div id="oper-logs">
        <el-table :data="logsList" style="width: 100%;" highlight-current-row>
            <el-table-column
                    :label="$STR('COMMON.common.table.operateDate', '操作时间')" :show-overflow-tooltip="true" prop="operateTime">
            </el-table-column>
            <el-table-column
                    :label="$STR('COMMON.common.table.operator', '操作人')" :show-overflow-tooltip="true" prop="userName">
            </el-table-column>
            <el-table-column
                    :label="$STR('BASE_SETTING.operLogs.ip', 'IP(城市)')" :show-overflow-tooltip="true" prop="userIp">
            </el-table-column>
            <el-table-column
                    :label="$STR('BASE_SETTING.operLogs.event', '事件备注')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{scope.row.userName}}
                        <span :class="{'green-text':scope.row.operateType==='INSERT'}" v-if="scope.row.operateTypeName==='INSERT'">{{scope.row.operateTypeName}}</span>
                         <span class="red-text" v-else>{{scope.row.operateTypeName}}</span>
                        {{scope.row.logTitle}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="count">
        </el-pagination>
    </div>
</template>
<script>
export default {
    props: ['id'],
    data () {
        return {
            logsList: [],
            count: 0,
            current: 1,
            rows: 20,
            order: 'createDate',
            asc: false
        };
    },
    mounted() {
    },
    created () {
        this.getLogsList();
    },
    watch: {
        id() {
            this.getLogsList();
        }
    },
    filters: {
    },
    methods: {
        handleSizeChange(val) {
            this.rows = val;
            this.getLogsList();
        },
        handleCurrentChange(val) {
            this.current = val;
            this.getLogsList();
        },
        getLogsList() {
            let _self = this;
            /*_self.$http.get(WebApi.logManager.selectLog, {
                params: {
                    current: _self.current,
                    rows: _self.rows,
                    order: _self.order,
                    asc: _self.asc,
                    tenantId: TENANTID,
                    entityIds: this.id
                }
            }).then(response => {
                _self.logsList = response.data.rows;
                if (response.data.length > 0) {
                    _self.count = response.data.total;
                }
            });*/

            if (this.id !== null && this.id !== '') {
                _self.$http.get(WebApi.logManager.selectLog, {
                    params: {
                        current: _self.current,
                        rows: _self.rows,
                        order: _self.order,
                        asc: _self.asc,
                        tenantId: baseStore.getTenantId(),
                        entityIds: this.id
                    }
                }).then(response => {
                    _self.logsList = response.data.rows;
                    if (response.data.length > 0) {
                        _self.count = response.data.total;
                    }
                });
            }

        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/operLogs.vue